// extracted by mini-css-extract-plugin
export default {"CustomLoading":"CustomLoading_CustomLoading__ZlcLr","Inline":"CustomLoading_Inline__ako+h","SVG":"CustomLoading_SVG__-orl1"};